/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InvitationResponseRole } from './invitationResponseRole';

export interface InvitationResponse {
  id: string;
  email: string;
  role: InvitationResponseRole;
  status: 'pending';
  token?: string | null;
  created_at: string;
}
